'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _BaseForm = require('./BaseForm');

var _BaseForm2 = _interopRequireDefault(_BaseForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Validated = function Validated(parent) {
    var _class, _temp;

    return _temp = _class = function (_parent) {
        (0, _inherits3.default)(_class, _parent);

        function _class() {
            (0, _classCallCheck3.default)(this, _class);

            var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));

            _this.state = (0, _extends3.default)({}, _this.state, {

                error: null,
                validate: false,
                validator: _this.getChildContextSchema().getValidator(_this.props.validator)
            });

            _this.onValidate = _this.validate = _this.onValidate.bind(_this);
            _this.onValidateModel = _this.validateModel = _this.onValidateModel.bind(_this);
            return _this;
        }

        (0, _createClass3.default)(_class, [{
            key: 'getChildContextError',
            value: function getChildContextError() {
                return (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'getChildContextError', this).call(this) || this.state.error;
            }
        }, {
            key: 'getNativeFormProps',
            value: function getNativeFormProps() {
                var _get$call = (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'getNativeFormProps', this).call(this),
                    onValidate = _get$call.onValidate,
                    validator = _get$call.validator,
                    validate = _get$call.validate,
                    props = (0, _objectWithoutProperties3.default)(_get$call, ['onValidate', 'validator', 'validate']);

                return props;
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(_ref) {
                var _this2 = this;

                var model = _ref.model,
                    schema = _ref.schema,
                    validate = _ref.validate,
                    validator = _ref.validator;

                (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'componentWillReceiveProps', this).apply(this, arguments);

                if (this.props.schema !== schema || this.props.validator !== validator) {
                    this.setState(function (_ref2) {
                        var bridge = _ref2.bridge;
                        return {
                            validator: bridge.getValidator(validator)
                        };
                    }, function () {
                        if (validate === 'onChange' || validate === 'onChangeAfterSubmit' && _this2.state.validate) {
                            _this2.onValidate();
                        }
                    });
                } else if (!(0, _isEqual2.default)(this.props.model, model)) {
                    if (validate === 'onChange' || validate === 'onChangeAfterSubmit' && this.state.validate) {
                        this.onValidateModel(model);
                    }
                }
            }
        }, {
            key: 'onChange',
            value: function onChange(key, value) {
                // eslint-disable-next-line max-len
                if (this.props.validate === 'onChange' || this.props.validate === 'onChangeAfterSubmit' && this.state.validate) {
                    this.onValidate(key, value).catch(function () {});
                }

                // FIXME: https://github.com/vazco/uniforms/issues/293
                // if (this.props.validate === 'onSubmit' && this.state.validate) {
                //     this.setState(() => ({error: null}));
                // }

                (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onChange', this).apply(this, arguments);
            }
        }, {
            key: 'onReset',
            value: function onReset() {
                (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onReset', this).call(this);
                this.setState(function () {
                    return { error: null, validate: false };
                });
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit(event) {
                var _this3 = this;

                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                var promise = new Promise(function (resolve, reject) {
                    _this3.setState(function () {
                        return { validate: true };
                    }, function () {
                        _this3.onValidate().then(function () {
                            (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onSubmit', _this3).call(_this3).then(resolve, function (error) {
                                _this3.setState({ error: error });
                                reject(error);
                            });
                        }, reject);
                    });
                });

                // NOTE: It's okay for this Promise to reject.
                promise.catch(function () {});

                return promise;
            }
        }, {
            key: 'onValidate',
            value: function onValidate(key, value) {
                var model = this.getChildContextModel();
                if (model && key) {
                    model = (0, _set2.default)((0, _cloneDeep2.default)(model), key, (0, _cloneDeep2.default)(value));
                }

                return this.onValidateModel(model);
            }
        }, {
            key: 'onValidateModel',
            value: function onValidateModel(model) {
                var _this4 = this;

                model = this.getModel('validate', model);

                var catched = this.props.error || null;
                try {
                    this.state.validator(model);
                } catch (error) {
                    catched = error;
                }

                return new Promise(function (resolve, reject) {
                    _this4.props.onValidate(model, catched, function () {
                        var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : catched;

                        // Do not copy error from props to state.
                        _this4.setState(function () {
                            return { error: error === _this4.props.error ? null : error };
                        }, function () {
                            if (error) {
                                reject(error);
                            } else {
                                resolve();
                            }
                        });
                    });
                });
            }
        }]);
        return _class;
    }(parent), _class.Validated = Validated, _class.displayName = 'Validated' + parent.displayName, _class.defaultProps = (0, _extends3.default)({}, parent.defaultProps, {
        onValidate: function onValidate(model, error, callback) {
            callback();
        },


        validate: 'onChangeAfterSubmit'
    }), _class.propTypes = (0, _extends3.default)({}, parent.propTypes, {

        onValidate: _propTypes2.default.func.isRequired,

        validator: _propTypes2.default.any,
        validate: _propTypes2.default.oneOf(['onChange', 'onChangeAfterSubmit', 'onSubmit']).isRequired
    }), _temp;
};

exports.default = Validated(_BaseForm2.default);


/*****************
 ** WEBPACK FOOTER
 ** ./~/uniforms/ValidatedForm.js
 ** module id = ./node_modules/uniforms/ValidatedForm.js
 ** module chunks = 0
 **/